import { useBrandConfigApiData } from './graphqlStaticQuery/useBrandConfigApiData'

function useFeatures(feature) {
  const { featuresFlags } = useBrandConfigApiData()

  return !!featuresFlags?.[feature]?.isEnabled
}

export default useFeatures
